import { render } from "./SettingAlert.vue?vue&type=template&id=3c516744"
import script from "./SettingAlert.vue?vue&type=script&lang=js"
export * from "./SettingAlert.vue?vue&type=script&lang=js"

import "./SettingAlert.vue?vue&type=style&index=0&id=3c516744&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__